import { NgModule } from '@angular/core';
@NgModule({
  exports: [],
})
export class PrimeNGModule {}
